import {
  type DropResult,
  DragDropContext,
  Droppable,
  Draggable,
  type DraggableProvided,
  type DraggableStateSnapshot,
} from 'react-beautiful-dnd'
import { type ReactNode } from 'react'
import { reorderArray } from '../lib/reorderArray'

type DragAndDropSectionProps<T> = {
  droppableId: string
  onDragEnd?: (result: DropResult) => void
  onReorder?: (orderedItems: T[]) => void
  items: T[]
  renderItem: (item: T, provided: DraggableProvided, snapshot: DraggableStateSnapshot) => ReactNode
  disableInteractiveElementBlocking?: boolean
}

export const DragAndDropSection = <T extends { key: string }>({
  droppableId,
  onDragEnd,
  onReorder,
  items,
  renderItem,
  disableInteractiveElementBlocking,
}: DragAndDropSectionProps<T>) => {
  return (
    <DragDropContext
      onDragEnd={(result) => {
        onDragEnd?.(result)

        if (onReorder && result.destination) {
          onReorder(reorderArray(items, result.source.index, result.destination.index))
        }
      }}
    >
      <Droppable droppableId={droppableId}>
        {(provided) => {
          return (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => {
                return (
                  <Draggable
                    key={item.key}
                    draggableId={item.key}
                    index={index}
                    disableInteractiveElementBlocking={disableInteractiveElementBlocking}
                  >
                    {(provided, snapshot) => {
                      return (
                        <div ref={provided.innerRef} {...provided.draggableProps}>
                          {renderItem(item, provided, snapshot)}
                        </div>
                      )
                    }}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}
